/* eslint-disable @next/next/no-img-element */
import React from 'react'
import styles from './MiniCart.module.scss'
import clsx from 'clsx'
import { NextRouter } from 'next/router'
import Link from 'next/link'
import { MdClose } from 'react-icons/md'
import { useWindowSize } from '~src/hook'

type EmptyCartProps = {
  router: NextRouter
  handleOpenCart: (visible: boolean) => void
}
export default function EmptyCart(props: EmptyCartProps) {
  const { router, handleOpenCart } = props

  const { isMobile } = useWindowSize()

  return (
    <div className={clsx(styles.emptyCartContainer)}>
      {isMobile && (
        <div className={styles.cartClose} onClick={() => handleOpenCart(false)}>
          <MdClose size={30} />
        </div>
      )}

      <div className={clsx(styles.mainContent, 'relative z-20')}>
        <h1>Giỏ hàng</h1>
        <p>Hiện tại giỏ hàng của bạn đang trống</p>
        {/* <button onClick={handleBackHome}>Về trang chủ</button> */}
        <Link href={'/'}>
          <a className="text-[1.4rem] mx-auto mt-[2rem] block w-fit sm:text-[1.8rem] font-semibold py-[1rem]  bg-success hover:text-white hover:bg-[#007134] rounded-full px-10 text-white cursor-pointer transition duration-300">
            Quay lại trang chủ
          </a>
        </Link>
      </div>
      <img className={clsx(styles.gearEmptyCart)} src="/image/gear-cart.png" alt="" />
      <img className={clsx(styles.emptyCart)} src="/image/empty-cart.png" alt="" />
      <img className={clsx(styles.emptyCartFooter)} src="/image/empty-cart-footer.png" alt="" />
    </div>
  )
}
